import React from 'react';
import {
  MeetMightyProStaticContainer,
  MeetMightyProStaticContent,
  RadialBackgroundStaticContainer,
} from './MeetMightyProStatic.styles';
import MeetMightyProContent from 'src/molecules/Standard/Homepage/2024_Q1_people_magic/MeetMightyProContent/MeetMightyProContent';

const MeetMightyProStatic = (): JSX.Element => {
  return (
    <MeetMightyProStaticContainer>
      <RadialBackgroundStaticContainer>
        <MeetMightyProStaticContent>
          <MeetMightyProContent
            ctaColor='Sunshine'
            sliderFullHeight={false}
          />
        </MeetMightyProStaticContent>
      </RadialBackgroundStaticContainer>
    </MeetMightyProStaticContainer>
  );
};

export default MeetMightyProStatic;
